import React, { useRef } from "react";
import { makeStyles, Hidden } from "@material-ui/core";
import ReactSwipe from "react-swipe";

const Carousel = ({ content, classes }) => {
  const reactSwipeEl = useRef(null);
  const swipeOptions = {
    auto: 2500,
    speed: 1200,
    disableScroll: true,
    continuous: true,
    draggable: true,
  };
  return (
    <ReactSwipe swipeOptions={swipeOptions} ref={reactSwipeEl} className={classes.carousel__container}>
      {content.map(({ label, picto }) => {
        return (
          <div key={label} className={classes.reinsurance__item}>
            <img src={picto} alt={label} />
            <p>{label}</p>
          </div>
        );
      })}
    </ReactSwipe>
  );
};

const Reinsurance = ({ content, darkMode }) => {
  const classes = useStyle({ darkMode });
  return (
    <>
      <Hidden mdUp implementation="css">
        <div className={classes.reinsurance__container}>
          <Carousel content={content} classes={classes} />
        </div>
      </Hidden>

      <Hidden smDown implementation="css">
        <div className={classes.reinsurance__container}>
          <div className={classes.itemsBox}>
            {content.map(({ label, picto }) => {
              return (
                <div key={label} className={classes.reinsurance__item}>
                  <img maxWidth="64px" src={picto} alt={label} />
                  <p>{label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </Hidden>
    </>
  );
};
export default Reinsurance;

const useStyle = makeStyles((theme) => ({
  itemsBox: {
    width: (props) => (props.darkMode ? "80%" : ""),
    justifyContent: "space-around",
    display: "flex",
    padding: 12,
    margin: "auto",
    [theme.breakpoints.down("md")]: {
      width: (props) => (props.darkMode ? "100%" : ""),
    },
  },
  reinsurance__container: {
    alignItems: "center",
    background: (props) => (props.darkMode ? theme.palette.secondary.dark : theme.palette.background.default),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  reinsurance__item: {
    display: "flex",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
    "& img": {
      maxWidth: 56,
    },

    "& p": {
      fontSize: 16,
      margin: "0 8px",
      whiteSpace: "nowrap",
      color: (props) => (props.darkMode ? "white" : theme.palette.secondary.dark),
      fontWeight: "400",

      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
      },
    },
  },
  carousel__container: {
    width: "100%",
  },
}));
